import type { OrderItem } from '@/pages/POS/types';

type ComboFields = Pick<
  OrderItem,
  | 'comboGroupId'
  | 'comboId'
  | 'comboSku'
  | 'comboName'
  | 'comboUnitQty'
  | 'comboUnitCount'
  | 'comboUnitPrice'
  | 'comboRetailTotal'
>;

function asString(value: unknown): string | undefined {
  return typeof value === 'string' && value !== '' ? value : undefined;
}

function asNumber(value: unknown): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}

/**
 * Đọc snapshot combo từ một dòng đơn API trả về (snake_case) sang `OrderItem`
 * (camelCase). Mongoose trả `null` cho field chưa set — quy hết về `undefined`
 * để `!item.comboGroupId` hoạt động đúng ở mọi nơi.
 */
export function readComboFields(source: Record<string, unknown>): ComboFields {
  return {
    comboGroupId: asString(source.combo_group_id),
    comboId: asString(source.combo_id),
    comboSku: asString(source.combo_sku),
    comboName: asString(source.combo_name),
    comboUnitQty: asNumber(source.combo_unit_qty),
    comboUnitCount: asNumber(source.combo_unit_count),
    comboUnitPrice: asNumber(source.combo_unit_price),
    comboRetailTotal: asNumber(source.combo_retail_total),
  };
}
